import { Component, inject } from "@angular/core";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { MatTabNav, MatTabLink, MatTabNavPanel } from "@angular/material/tabs";

@Component({
  selector: "app-codes-home",
  templateUrl: "./codes-home.component.html",
  styleUrls: ["./codes-home.component.css"],
  imports: [MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, RouterOutlet]
})
export class CodesHomeComponent {
  private router = inject(Router);
  clientConfig = inject(ClientConfigService);

  activeLink: string = "";
  enableTimesheet = false;

  constructor() {
    const router = this.router;

    this.activeLink = router.url;
    this.enableTimesheet = this.clientConfig?.config?.enableTimesheetCodes;
  }
}
